import { useRef, useCallback } from 'react';
import { useMeetingSelector } from '../meeting/meetingProviderContextDef';

const selectMeeting = s => s.meeting;

const useFile = () => {
  const meeting = useMeetingSelector(selectMeeting);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;

  const uploadBase64File = useCallback(
    async ({ base64Data, token, fileName }) => {
      if (!meetingRef.current) return;
      return await meetingRef.current.uploadBase64File({
        base64Data,
        token,
        fileName
      });
    },
    []
  );

  const fetchBase64File = useCallback(async ({ url, token }) => {
    if (!meetingRef.current) return;
    return await meetingRef.current.fetchBase64File({ url, token });
  }, []);

  return { uploadBase64File, fetchBase64File };
};

export default useFile;
